import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Clock, DollarSign, MoreHorizontal } from 'lucide-react';
import { cn } from '../../lib/cn';

const TABS = [
  { to:'/dashboard',  icon:LayoutDashboard, label:'Home'      },
  { to:'/employees',  icon:Users,           label:'People'    },
  { to:'/attendance', icon:Clock,           label:'Attendance'},
  { to:'/payroll',    icon:DollarSign,      label:'Payroll'   },
  { to:'/settings',   icon:MoreHorizontal,  label:'More'      },
];

export function MobileBottomNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-[var(--bg-elevated)] border-t border-[var(--border)] flex items-center pb-safe" style={{paddingBottom:'env(safe-area-inset-bottom,0)'}}>
      {TABS.map(({to,icon:Icon,label})=>(
        <NavLink key={to} to={to} className={({isActive})=>cn('flex-1 flex flex-col items-center justify-center py-2 gap-0.5 transition-colors',isActive?'text-[var(--accent)]':'text-[var(--text-tertiary)]')}>
          <Icon size={22} strokeWidth={isActive=>isActive?2.5:2}/>
          <span className="text-[10px] font-medium">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
export default MobileBottomNav;
